import "./index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import { Toaster } from "./components/ui/sonner";

import HomePage from "./pages/HomePage";
import SearchPage from "./pages/SearchPage";
import DocsPage from "./pages/DocsPage";
import LoginPage from "./pages/LoginPage";
import AuthCallback from "./pages/AuthCallback";
import AdminDashboard from "./pages/AdminDashboard";
import DraftPreview from "./pages/DraftPreview";
import ChangelogPage from "./pages/ChangelogPage";

function App() {
    return (
        <ThemeProvider>
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/search" element={<SearchPage />} />
                        <Route path="/changelog" element={<ChangelogPage />} />
                        <Route path="/docs/:projectSlug" element={<DocsPage />} />
                        <Route path="/docs/:projectSlug/:docSlug" element={<DocsPage />} />
                        <Route path="/login" element={<LoginPage />} />
                        <Route path="/auth/callback" element={<AuthCallback />} />
                        <Route path="/admin" element={<AdminDashboard />} />
                        <Route path="/admin/preview/:docId" element={<DraftPreview />} />
                    </Routes>
                </BrowserRouter>
                <Toaster position="bottom-right" />
            </AuthProvider>
        </ThemeProvider>
    );
}

export default App;
